<template>
  <div class="password">
    <!-- TODO добавить переводы и в label -->
    <p>To enter the software - please come up with a password</p>
    <app-text-input label="Password" v-model="pass" type="password"/>
    <app-text-input label="Repeat password" v-model="confirm" type="password"/>
    <app-btn :loading="loading" @click="next">{{$ml.get('next')}}</app-btn>
  </div>
</template>

<script>
import { QuickRegAPI } from '@/api';

export default {
  data() {
    return {
      pass: '',
      confirm: '',
      loading: false,
    }
  },

  methods: {


    next() {

      if(this.pass !== this.confirm) {
        this.$notify({
          group: 'notices',
          title: 'Passwords doesn\'t match',
          type: 'error',
        });
        return; 
      }

      QuickRegAPI.changePass(this.pass).then(res => {
        this.$store.dispatch('user/updateData').then(() => {
          this.$router.push('/dashboard');
        }).finally(() => {
          this.loading = false;
        });
      }).catch(err => {
        this.loading = false;
      });
    }
  },
}
</script>

<style lang="scss" scoped>

.password {
  background: #fff;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    width: 300px;
    line-height: 1.5;
  }

  .app-text-input {
    width: 300px;
    margin-bottom: 20px;
  }
}

</style>